export interface RootState {
    lastConnectedTime: number | undefined;
    isOnline: boolean;
}

export const state: RootState = {
    lastConnectedTime: undefined,
    isOnline: false,
};
